import { combineReducers } from 'redux';

import { RoutesState } from '../schedule.model';
import {
    onDemandTripsReducer,
    OnDemandTripsState,
    ONDEMAND_TRIPS_INITIAL_STATE,
    ONDEMAND_TRIPS_STATE_KEY
} from './ondemand-trips/ondemand-trips.reducer';
import {
    plannerReducer,
    PlannerState,
    PLANNER_INITIAL_STATE,
    PLANNER_STATE_KEY
} from './planner/planner.reducer';
import {
    routeDirectionReducer,
    RouteDirectionState,
    ROUTE_DIRECTION_INITIAL_STATE,
    ROUTE_DIRECTION_STATE_KEY,
} from './route-direction/route-direction.reducer';
import {
    routeSearchReducer,
    RouteSearchState,
    ROUTE_SEARCH_INITIAL_STATE,
    ROUTE_SEARCH_STATE_KEY,
} from './route-search/route-search.reducer';
import {
    routeStopsReducer,
    RouteStopsState,
    ROUTE_STOPS_INITIAL_STATE,
    ROUTE_STOPS_STATE_KEY,
} from './route-stops/route-stops.reducer';
import {
    routeTripReducer,
    RouteTripState,
    ROUTE_TRIP_INITIAL_STATE,
    ROUTE_TRIP_STATE_KEY
} from './route-trip/route-trip.reducer';
import { routesReducer, ROUTES_INITIAL_STATE, ROUTES_STATE_KEY } from './routes/routes.reducer';

export const SCHEDULE_STATE_KEY = 'schedule';

export interface ScheduleState {
    [ROUTES_STATE_KEY]: RoutesState;
    [ROUTE_DIRECTION_STATE_KEY]: RouteDirectionState;
    [ROUTE_STOPS_STATE_KEY]: RouteStopsState;
    [ROUTE_SEARCH_STATE_KEY]: RouteSearchState;
    [ROUTE_TRIP_STATE_KEY]: RouteTripState;
    [PLANNER_STATE_KEY]: PlannerState;
    [ONDEMAND_TRIPS_STATE_KEY]: OnDemandTripsState;
}

export const SCHEDULE_INITIAL_STATE: ScheduleState = {
    [ROUTES_STATE_KEY]: ROUTES_INITIAL_STATE,
    [ROUTE_DIRECTION_STATE_KEY]: ROUTE_DIRECTION_INITIAL_STATE,
    [ROUTE_STOPS_STATE_KEY]: ROUTE_STOPS_INITIAL_STATE,
    [ROUTE_SEARCH_STATE_KEY]: ROUTE_SEARCH_INITIAL_STATE,
    [ROUTE_TRIP_STATE_KEY]: ROUTE_TRIP_INITIAL_STATE,
    [PLANNER_STATE_KEY]: PLANNER_INITIAL_STATE,
    [ONDEMAND_TRIPS_STATE_KEY]: ONDEMAND_TRIPS_INITIAL_STATE,
};

export const scheduleReducer = combineReducers<any>({
    [ROUTES_STATE_KEY]: routesReducer,
    [ROUTE_DIRECTION_STATE_KEY]: routeDirectionReducer,
    [ROUTE_STOPS_STATE_KEY]: routeStopsReducer,
    [ROUTE_SEARCH_STATE_KEY]: routeSearchReducer,
    [ROUTE_TRIP_STATE_KEY]: routeTripReducer,
    [PLANNER_STATE_KEY]: plannerReducer,
    [ONDEMAND_TRIPS_STATE_KEY]: onDemandTripsReducer,
});

export interface SchedulePartialStoreState {
    [SCHEDULE_STATE_KEY]: ScheduleState;
}
